import { useEffect, useRef } from 'react';
import { trackScrollDepth, trackTimeOnPage } from '../utils/analytics';

export const useScrollTracking = () => {
  const lastScrollDepth = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.round((scrollTop / docHeight) * 100);

      // Track at 25%, 50%, 75%, and 100% scroll depths
      if (scrollPercent >= 25 && lastScrollDepth.current < 25) {
        trackScrollDepth(25);
        lastScrollDepth.current = 25;
      } else if (scrollPercent >= 50 && lastScrollDepth.current < 50) {
        trackScrollDepth(50);
        lastScrollDepth.current = 50;
      } else if (scrollPercent >= 75 && lastScrollDepth.current < 75) {
        trackScrollDepth(75);
        lastScrollDepth.current = 75;
      } else if (scrollPercent >= 100 && lastScrollDepth.current < 100) {
        trackScrollDepth(100);
        lastScrollDepth.current = 100;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

export const useTimeTracking = () => {
  const startTime = useRef(Date.now());
  const lastTrackedTime = useRef(0);

  useEffect(() => {
    const trackTime = () => {
      const currentTime = Date.now();
      const timeOnPage = (currentTime - startTime.current) / 1000; // Convert to seconds
      
      // Track every 30 seconds
      if (timeOnPage - lastTrackedTime.current >= 30) {
        trackTimeOnPage(timeOnPage);
        lastTrackedTime.current = timeOnPage;
      }
    };

    const interval = setInterval(trackTime, 30000); // Check every 30 seconds

    // Track time on page when user leaves
    const handleBeforeUnload = () => {
      const timeOnPage = (Date.now() - startTime.current) / 1000;
      trackTimeOnPage(timeOnPage);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      clearInterval(interval);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};

export const useAnalytics = () => {
  useScrollTracking();
  useTimeTracking();
}; 